import {ResponsiveContent} from "../../../ResponsiveNavTabs";
import React, {useRef, useState} from "react";
import {
    ItemLoading,
    MenuAdd,
    MenuBar,
    MenuClearSelectButton,
    MenuConfirmDeleteButton,
    MenuOrderBy,
    MenuSearchTerm,
    OurClearAlert,
    OurPagination2,
    PageTitle
} from "../../../_components";
import {useTip, useTipCount, useTipList, useTipOrderOptions} from "./useTip";
import {Button, ListGroup, Stack} from "react-bootstrap";
import {useAlert, useAuth} from "../../../../context";
import {useLocalFilter2, useLongPress, useSelect, useTouch} from "../../../../hooks";
import {Link} from "react-router-dom";


export function Tips() {
    return <ResponsiveContent body={<TipsForm/>}/>
}

function TipsForm() {
    const {userId} = useAuth()
    const {success} = useAlert()

    // Get order options
    const {orderOptions, errorOrderOptions, clearErrorOrderOptions} = useTipOrderOptions()

    // API Actions
    const {deleteItem, errorValue, clearErrorValue} = useTip(userId)

    // API count all items
    const {count, setCount, loadingCount, errorCount, clearErrorCount} = useTipCount()

    // API items per page
    const {list, setList, loadingList, errorList, clearErrorList} = useTipList()

    // Filter
    const filteredList = useLocalFilter2(list, ["title"])

    // Select
    const [selList, toggleSelectItems, clearSelectItems, isItemSelected] = useSelect(list)


    function handleOnItemsDelete() {
        selList
            .forEach(item =>
                deleteItem(item.id)
                    .then(() => {
                        setCount(count => count - 1)
                        setList(prev => prev.filter(obj => obj.id !== item.id))
                        success(`${item.title} has been deleted!`)
                    })
                    .catch(err => console.warn(err.message))
            )
        clearSelectItems()
    }
return <Stack>

    <OurClearAlert variant="danger" msg={errorOrderOptions} onClear={clearErrorOrderOptions}/>
    <OurClearAlert variant="danger" msg={errorCount} onClear={clearErrorCount}/>
    <OurClearAlert variant="danger" msg={errorList} onClear={clearErrorList}/>
    <OurClearAlert variant="danger" msg={errorValue} onClear={clearErrorValue}/>

    <PageTitle title="Tips">Manage {list.length} of {count} tips.</PageTitle>

    <MenuBar>
        <MenuAdd to="/backend/tip/add" icon="plus">Add</MenuAdd>
        <MenuSearchTerm/>
        <MenuOrderBy orderOptions={orderOptions}/>
        <MenuClearSelectButton hide={selList.length === 0} onClick={clearSelectItems}>
            {selList.length} {selList.length === 1 ? "row" : "rows"}
        </MenuClearSelectButton>
        <MenuConfirmDeleteButton hide={selList.length === 0} onSubmit={handleOnItemsDelete}>
            {selList.length} {selList.length === 1 ? "tip" : "tips"}
        </MenuConfirmDeleteButton>
    </MenuBar>

    <ItemLoading show={loadingCount || loadingList}/>

    {list && list.length > 0 ?
        <ListGroup variant="flush">
            {filteredList.map(item =>
                <RenderItem key={item.id} item={item} selected={isItemSelected(item.id)} selectedCount={selList.length} onSelect={toggleSelectItems}
                            to={`/backend/tip/${item.id}`}/>
            )}
        </ListGroup>
        :
        <span className="text-center">No tip added yet</span>
    }

    <OurPagination2 loading={loadingCount || loadingList} itemCount={count}/>

    </Stack>
}

function RenderItem({item, selected, selectedCount, onSelect, to}) {
    const touch = useTouch()
    const [show, setShow] = useState(false)

    const ref = useRef(null)
    useLongPress(ref, () => onSelect(item.id))

    return (
        // <Stack direction="horizontal" gap="2" className={`mb-1 rounded ${selected && "bg-light"} ${show && "bg-light-subtle"}`}
        <Stack direction="horizontal" gap="2" className={`mb-1 rounded ${(selected || show) && "bg-light-subtle"}`}
               onMouseEnter={() => setShow(true)}
               onMouseLeave={() => setShow(false)}>
            <Stack ref={ref} direction="horizontal" className="flex-grow-1" gap="2">
                <div>
                    <i className="bi bi-chat-square-text fs-3"/>
                </div>
                <div>
                    <Stack direction="vertical" className="" gap={0}>
                        <Link to={to}
                              className="flex-shrink-0 link-body-emphasis link-underline link-underline-opacity-0 link-underline-opacity-75-hover link-offset-1 link-offset-1-hover">
                            <span className="text-wrap fw-semibold fs-4">{item.title}</span>
                        </Link>
                        {/*<span className="text-wrap fs-6 fw-light">{item.name}</span>*/}
                    </Stack>
                </div>
                {/*<div className="ms-auto">*/}
                {/*    <Stack className="text-body-tertiary align-items-end justify-content-center" gap={0}>*/}
                {/*        <span className="text-nowrap fw-normal text-secondary">€{item.price}</span>*/}
                {/*        <span className="text-nowrap fw-normal text-secondary">Countries: {item.countries.length}</span>*/}
                {/*    </Stack>*/}
                {/*</div>*/}
            </Stack>

            <div className="ms-auto">
                {(!touch || selected || selectedCount > 0) &&
                    <Button className="link-underline link-underline-opacity-0" variant="link" onClick={() => onSelect(item.id)}>
                        <span className={`bi ${selected ? "bi-check-square" : "bi-square"}`}></span>
                    </Button>
                }
            </div>
        </Stack>
    )

}
